import React from 'react';
import OtpAuthCard from '../components/OtpAuthCard';

export default function UserLogin() {
  return (
    <OtpAuthCard
      mode="login"
      title="Login with OTP"
      subtitle="Enter your phone number. No email or password needed."
    />
  );
}
